export default {
    setFinanciadorId(state, payload) {
      state.financiadorId = payload;
    },
    setFinanciadorNom(state, payload) {
      state.financiadorNom = payload;
    },
    setFinanciadorUsaGecros(state, payload) {
      state.financiadorUsaGecros = payload;
    },
};
  